import { IntlProvider, useFetchMessages } from '@faceup/localization'
import { FullPageSpin } from '@faceup/ui'
import { DEFAULT_LANGUAGE, languageEnumToBasename } from '@faceup/utils'
import * as Sentry from '@sentry/react'
import { Suspense, useEffect, useState } from 'react'
import AppProviders from './AppProviders'
import AppRouter from './Pages/AppRouter'

const App = () => {
  const [messages, setMessages] = useState<Record<string, string>>()
  const { getMessages } = useFetchMessages({
    handleNewMessages: setMessages,
    onError: (error, { source, language }) =>
      Sentry.captureException(error, { tags: { source }, extra: { language } }),
    onWarning: (message, { source, language, extra }) =>
      Sentry.captureMessage(message, {
        level: 'warning',
        tags: source ? { source } : undefined,
        extra: { ...extra, language },
      }),
  })

  useEffect(() => {
    void getMessages(DEFAULT_LANGUAGE).then(setMessages)
  }, [getMessages])

  return (
    <IntlProvider
      locale={languageEnumToBasename(DEFAULT_LANGUAGE)}
      messages={messages}
      onError={() => {
        // Ignore errors
      }}
    >
      <AppProviders>
        <Suspense fallback={<FullPageSpin />}>
          <AppRouter />
        </Suspense>
      </AppProviders>
    </IntlProvider>
  )
}

export default Sentry.withProfiler(App)
